import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ConfigService } from '../utils/config-service';
import { GlobalName } from '../utils/global-name';
import { LocalStorageService } from '../utils/local-stoarge-service';
import { BehaviorSubject, Observable } from 'rxjs';
import { tap } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthService {

  url :string =ConfigService.toApiUrl("logout");
  url2 :string =ConfigService.toFile('');
  private _isAuthenticated = new BehaviorSubject<boolean>(false);
  public isReady = new BehaviorSubject<boolean>(false);


  constructor(private appLocalStorage: LocalStorageService, private http:HttpClient) {
     const token = this.appLocalStorage.get(GlobalName.tokenName);
      if (token) {
            this._isAuthenticated.next(true);
            this.isReady.next(true); 
      } else {
        this._isAuthenticated.next(false);
        this.isReady.next(true);
      }
   }
   
  isAuthenticated(): Observable<boolean> {
    return this._isAuthenticated.asObservable();
  }


  getJWTToken(){
    return this.appLocalStorage.get(GlobalName.tokenName)
  }
  setJWTToken(token:any){
    return this.appLocalStorage.set(GlobalName.tokenName,token)
  }
  setJWTRefreshToken(token:any){
    return this.appLocalStorage.set(GlobalName.refreshTokenName,token)
  }

  me(){
    return this.http.get<any>(`${this.url2}api/user`,
     ConfigService.httpHeader(null,true));
  }

  /**
   * Recharge l'utilisateur courant (rôles + permissions à jour) depuis le
   * backend et met à jour le localStorage — même forme qu'au login.
   * Évite d'avoir à se reconnecter après un changement de droits.
   */
  refreshCurrentUser(): Observable<any> {
    return this.me().pipe(
      tap((res: any) => {
        const data = res?.data ?? res;
        if (data?.user) {
          this.appLocalStorage.set(GlobalName.userName, data.user);
          if (data.features) this.appLocalStorage.set(GlobalName.features, data.features);
        }
      })
    );
  }

  login(ressource:any){

    /*ressource['grant_type']=LoginParamProd.grantType;
    ressource['client_id']=LoginParamProd.clientId;
    ressource['client_secret']=LoginParamProd.clientSecret;
    ressource['scope']=LoginParamProd.scope;*/

    return this.http.post<any>(`${this.url2}api/login`, ressource,
     ConfigService.httpHeader(null,true));
  }

  sendMail(ressource:any){
    return this.http.post<any>(`${this.url2}api/send-reset-password-link`, ressource,
     ConfigService.httpHeader(null,true));
  }


  
  update(ressource:any){
    return this.http.post<any>(`${this.url2}api/update-profile`, ressource,ConfigService.addAction('MODIFIER'));
  }

  recoverPassword(token:any,ressource:any){
    return this.http.post<any>(`${this.url2}api/recovery-password/${token}`, ressource,
     ConfigService.httpHeader(null,true));
  }


  logout(){
    return this.http.get<any>(`${this.url}`);
  }

  changePassword(ressource:any){

    return this.http.post<any>(`${this.url2}api/change-password`, ressource,ConfigService.addAction('MODIFIER'));
    }
    changeFirstPassword(ressource:any){

    return this.http.post<any>(`${this.url2}api/change-first-password`, ressource,
    ConfigService.httpHeader(null,true));
    }

    saveDB(){

      return this.http.get<any>(`${this.url2}api/save-db`,ConfigService.addAction('CREER'));
      }

      getBackups(){

        return this.http.get<any>(`${this.url2}api/backups`,ConfigService.addAction('LISTER'));
        }

  // ── MFA (6.1) ──────────────────────────────────────────────────────────────
  verifyMfa(user_ref: string, code: string, device = 'web'): Observable<any> {
    return this.http.post<any>(`${this.url2}api/mfa/verify`, { user_ref, code, device }, ConfigService.httpHeader(null, true));
  }

  getMfaSettings(): Observable<any> {
    return this.http.get<any>(`${this.url2}api/mfa/settings`, ConfigService.addAction('LISTER'));
  }

  updateMfaSettings(use_2FA: boolean, mode_2FA?: string): Observable<any> {
    return this.http.put<any>(`${this.url2}api/mfa/settings`, { use_2FA, mode_2FA }, ConfigService.addAction('MODIFIER'));
  }
}
